import { useEffect } from "react";
import BannerCaroussel from "./carousel";
import {
  BannerContainer,
  Container,
  ContentContainer,
  InProgressButton,
  InProgressContent,
  InProgressLesson,
  InProgressSection,
  InProgressText,
  InProgressTitle,
  OnGoingContainer,
  OnGoingContentContainer,
  SectionTitle,
} from "./style";
import CourseList from "./courses";
import { FaPlayCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  setBanner,
  setCourses,
} from "../../redux/modules/informaAcademy/actions";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useNotification from "../../hooks/newUXNotification";
import useEventCode from "../../hooks/useEventCode";

const PreviewHomepageBanner = () => {
  const dispatch = useDispatch();
  const { event } = useSelector((state) => state.initialSettings);
  const eventId = event.value;
  const notification = useNotification();
  const intl = useIntl();
  const history = useHistory();

  const { courses, allowAccess, onGoingCourses, banners } = useSelector(
    (state) => state.informaAcademy
  );

  useEffect(() => {
    dispatch(setBanner({}));
    dispatch(setCourses({}));
  }, [dispatch, eventId]);

  useEffect(() => {
    if (!allowAccess) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.homepage_not_allowed" }),
        "error.homepage_not_allowed"
      );

      history.push("/home");
    }

    if (isNaN(event?.value)) {
      history.push("/home");
    }

    return;
  }, [allowAccess, event?.value, history, intl, notification]);

  if (banners?.length === 0 || courses?.length === 0) return null;

  return (
    <Container>
      <BannerContainer>
        <BannerCaroussel banners={banners} />
      </BannerContainer>

      <OngoingCourses courses={courses} onGoingCourses={onGoingCourses} />

      <ContentContainer>
        <CourseList courses={courses} />
      </ContentContainer>
    </Container>
  );
};

export default PreviewHomepageBanner;

function OngoingCourses({ onGoingCourses, courses }) {
  if (onGoingCourses?.length === 0) return null;

  return (
    <OnGoingContainer>
      <SectionTitle>
        <FormattedMessage id="homepage.onGoing" />
      </SectionTitle>
      <OnGoingContentContainer>
        {OngoingCoursesInfo({
          coursesArray: courses,
          ongoingArray: onGoingCourses,
        }).map((course) => (
          <OngoingCourse course={course} key={course.courseId} />
        ))}
      </OnGoingContentContainer>
    </OnGoingContainer>
  );
}

function OngoingCourse({ course }) {
  const eventCode = useEventCode();

  return (
    <InProgressSection>
      <InProgressContent>
        <InProgressText
          to={`/informa-academy/${eventCode}/course/${course.courseId}`}
        >
          <FormattedMessage id="homepage.course" />
        </InProgressText>
        <InProgressTitle>{course.courseTitle}</InProgressTitle>
        <InProgressLesson>{course.currentLessonTitle}</InProgressLesson>
      </InProgressContent>

      <InProgressButton
        to={`/informa-academy/${eventCode}/course/${course.courseId}/lesson/${course.lessonId}`}
      >
        <FaPlayCircle />
        <FormattedMessage id="homepage.continue" />
      </InProgressButton>
    </InProgressSection>
  );
}

function OngoingCoursesInfo({ ongoingArray, coursesArray }) {
  return ongoingArray.map((ongoing) => {
    const matchedCourse = coursesArray.find(
      (course) => course.courseTitle === ongoing.courseTitle
    );

    if (matchedCourse) {
      const matchedLesson = matchedCourse.lessons.find(
        (lesson) => lesson.urlVideo === ongoing.lessonUrl
      );

      // const nextLessonInfo = getNextLessonInfo({
      //   lessons: matchedCourse.lessons,
      // });

      return {
        ...ongoing,
        courseId: matchedCourse.courseId,
        // lessonId: matchedLesson?.lessonId,
        // lessonUrl: `/informa-academy/course/${matchedCourse.courseId}/lesson/${nextLessonInfo.lessonId}`,
      };
    }

    return ongoing;
  });
}
